import {Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {InformationFormComponent} from "../information-form/information-form.component";

export interface DialogData {
  title: string;
  cancelButtonLabel: string;
  submitButtonLabel: string;
}

@Component({
  selector: 'app-resetpasswort-form',
  templateUrl: './resetPasswort-form.component.html',
  styleUrls: ['./resetPasswort-form.component.scss']
})
export class ResetPasswortFormComponent implements OnInit {



  constructor(public dialogRef: MatDialogRef<ResetPasswortFormComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              public dialog: MatDialog,
              private http: HttpClient) {
    dialogRef.disableClose = true;
  }

  public resetPasswortForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(255), Validators.pattern('^[a-záéíóúàèìòùâêîôûäëïöüñõçßÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÕÇ0-9._%+-]+@[a-záéíóúàèìòùâêîôûäëïöüñõçßÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÕÇ0-9.-]+\\.[a-z]{2,4}$')])
  });

  ngOnInit(): void { }

  /* Ja / Nein Buttons in im Löschen Bestätigungsformular */
  // tslint:disable-next-line:typedef
  public resetPasswort() {
    const email = this.resetPasswortForm.value.email;

    // Check ob Email vorhanden ist in myDay
    this.http.get
    (
      `https://local.curion.ch/myDay/backend/checkIfActiveUserExists.php?email=${email}`,
      {responseType: 'json'}
    ).subscribe((data: {data: {aktiv: number}}) => {
      // 0 == USER IST NICHT AKTIV
      if(data.data.aktiv == 0 || data.data.aktiv == 1){
        // USER EXISTIERT -> Neues Kenntwort zuschicken
        // Rico zurücksetz Funktion einbauen
        const response = this.http.get
        (
          `https://local.curion.ch/AccMan/rstpwd.php?app=1003&email=${email}`,
          {responseType: 'text'}
        );
        response.subscribe();
        this.dialogRef.close(true);
      }
      // HEISST AKTIV == NULL WAS BEDEUTET DAS DER USER NICHT EXISTIERT
      else {
        const okDialog = this.dialog.open(InformationFormComponent, {
          data: {
            title: 'pages.login.resetPasswortDialog.errorTitle',
            text: 'pages.login.resetPasswortDialog.error'
          }
        });
        // RETURN FALSE
      }
    });


    this.dialogRef.close(false);
  }

  // tslint:disable-next-line:typedef
  public noHandleClick() {
    this.dialogRef.close(false);
  }

  public getErrorMessage(Feld: string): string {
    const formControl = this.resetPasswortForm.get(Feld);
    if (formControl.hasError('required')){
      return`pages.login.resetPasswordDialog.error.required`;
    }
    return 'pages.login.resetPasswordDialog.error.generic';
  }
  /* ENDE Ja / Nein Buttons in im Löschen Bestätigungsformular */
  /* ENDE Menue vor dem Löschen bzw. Werte dem ja Pfad zuweisen */
}
